import { Emitter } from "@siteimprove/alfa-emitter";
import { Serializable } from "@siteimprove/alfa-json";
import { now } from "./now.js";
/**
 * @public
 */
export class Performance {
    static of() {
        return new Performance();
    }
    _epoch = now();
    _emitter = Emitter.of();
    constructor() { }
    get epoch() {
        return this._epoch;
    }
    now() {
        return now() - this._epoch;
    }
    elapsed(now) {
        return now ? now - this._epoch : this.now();
    }
    mark(data, start = this.now()) {
        if (typeof start !== "number") {
            start = start.start;
        }
        return this._emit(Performance.mark(data, start));
    }
    measure(data, start = this._epoch, end = this.now()) {
        if (typeof start !== "number") {
            start = start.start;
        }
        if (typeof end !== "number") {
            end = end.start;
        }
        return this._emit(Performance.measure(data, start, end - start));
    }
    on(listener) {
        this._emitter.on(listener);
        return this;
    }
    once(listener) {
        if (listener) {
            this._emitter.once(listener);
            return this;
        }
        else {
            return this._emitter.once();
        }
    }
    off(listener) {
        this._emitter.off(listener);
        return this;
    }
    asyncIterator() {
        return this._emitter.asyncIterator();
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    toJSON() {
        return {};
    }
    _emit(entry) {
        this._emitter.emit(entry);
        return entry;
    }
}
/**
 * @public
 */
(function (Performance) {
    function isPerformance(value) {
        return value instanceof Performance;
    }
    Performance.isPerformance = isPerformance;
    class Mark {
        static of(data, start) {
            return new Mark(data, start);
        }
        _data;
        _start;
        constructor(data, start) {
            this._data = data;
            this._start = start;
        }
        get type() {
            return "mark";
        }
        get data() {
            return this._data;
        }
        get start() {
            return this._start;
        }
        toJSON() {
            return {
                type: "mark",
                data: Serializable.toJSON(this._data),
                start: this._start,
            };
        }
    }
    Performance.Mark = Mark;
    (function (Mark) {
        function isMark(value) {
            return value instanceof Mark;
        }
        Mark.isMark = isMark;
    })(Mark = Performance.Mark || (Performance.Mark = {}));
    Performance.mark = Mark.of, Performance.isMark = Mark.isMark;
    class Measure {
        static of(data, start, duration) {
            return new Measure(data, start, duration);
        }
        _data;
        _start;
        _duration;
        constructor(data, start, duration) {
            this._data = data;
            this._start = start;
            this._duration = duration;
        }
        get type() {
            return "measure";
        }
        get data() {
            return this._data;
        }
        get start() {
            return this._start;
        }
        get duration() {
            return this._duration;
        }
        toJSON() {
            return {
                type: "measure",
                data: Serializable.toJSON(this._data),
                start: this._start,
                duration: this._duration,
            };
        }
    }
    Performance.Measure = Measure;
    (function (Measure) {
        function isMeasure(value) {
            return value instanceof Measure;
        }
        Measure.isMeasure = isMeasure;
    })(Measure = Performance.Measure || (Performance.Measure = {}));
    Performance.measure = Measure.of, Performance.isMeasure = Measure.isMeasure;
})(Performance || (Performance = {}));
//# sourceMappingURL=performance.js.map